import React, { memo } from "react";
import { HighchartsReact } from "investira.react.charts";

const DivergenciasChart = memo((props) => {
  const { data = [] } = props;

  const processData = (data) => {
    const xMainData = [];

    Object.entries(data).forEach(([_key, item]) => {
      xMainData.push({
        name: item.descricao,
        y: item.quantidade_ativos,
        dataLabels: {
          color: "#FFFFFF",
        },
        metadata: {
          name: item.descricao,
          quantidade_ativos: item.quantidade_ativos,
        },
      });
    });

    return xMainData;
  };

  const xData = processData(data);

  const xOptions = {
    chart: {
      type: "pie",
      height: "320px",
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: "50%",
        borderColor: "#2e2e46",
        borderWidth: 2, // Largura do contorno
        shadow: false,
        center: ["50%", "50%"],
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            return `
                          <span style="color: #FFFFFF; text-decoration: none;">${this.point.name}</span><br/>
                          <span style="color: #FFFFFF; text-decoration: none;">
                           ${this.point.metadata.quantidade_ativos}
                          </span>`;
          },
          style: {
            color: "#FFFFFF",
            textOutline: "none",
          },
        },
      },
    },
    series: [
      {
        name: "Divergências",
        colorByPoint: true,
        data: xData,
      },
    ],
    tooltip: {
      enabled: false, // Tooltip desativado
    },
  };

  return <HighchartsReact options={xOptions} drilldown />;
});

export default DivergenciasChart;
